module.exports = __webpack_public_path__ + "img/b97c91e.png";